'use client';

import { Tab, TabList, Tabs } from '@bytel/trilogy-react';

import { HomePackResponseWithCategories, PACK_HASH } from '@app-types/home-pack';

import { replaceWindowUrl } from '@helpers/document';
import { paths } from '@helpers/path';

import { sendComboTabChangePageTracking } from '@home-pack/helpers';

type PackHashKeys = keyof typeof PACK_HASH;
type HomePackProps = {
    currentHash: PACK_HASH;
    staticsCategories?: HomePackResponseWithCategories;
    setSlug: (slug: string) => void;
};

export function HomePackTabs({ currentHash, staticsCategories, setSlug }: Readonly<HomePackProps>) {
    if (
        !staticsCategories ||
        !staticsCategories.categoryProductsSamsung ||
        !staticsCategories.categoryProductsSamsung.length
    ) {
        return null;
    }

    const handleTabChange = (slug: string) => {
        const url = `${paths.homePack}/${slug}`;
        setSlug(slug);
        replaceWindowUrl(url);
        sendComboTabChangePageTracking(slug);
    };

    return (
        <Tabs small onClick={function noRefCheck() {}}>
            <TabList className='is-justified-center'>
                {staticsCategories.categoryProductsSamsung
                    ?.filter(
                        (productCategory) =>
                            productCategory.categoryName && (productCategory.productsSamsung?.length || 0) > 0,
                    )
                    ?.sort((a, b) => a.order - b.order)
                    ?.map((productCategory) => {
                        const slugKey = productCategory.slug?.toUpperCase() as PackHashKeys;
                        return (
                            <Tab
                                routerLink='a'
                                key={productCategory.id}
                                label={productCategory.categoryName!}
                                onClick={(e) => {
                                    (e as Event).preventDefault();
                                    handleTabChange(productCategory.slug!);
                                }}
                                id={productCategory.slug}
                                active={currentHash.toUpperCase() === slugKey.toUpperCase()}
                                href={`${paths.homePack}/${productCategory.slug}`}
                                iconName={productCategory.icon}
                            />
                        );
                    })}
            </TabList>
        </Tabs>
    );
}
